import React, { useEffect } from 'react';

// assets

// services
import DataCountryService from '../../../../../services/data/geographics/country';

// props
import { IDataCountryResourceShortProps } from '../../../../../props/data/geographics/countries';

// components
import { Dropdown, DropdownMenuItemType, IDropdownOption, SpinnerSize, Stack } from '@fluentui/react';
import Label from '../../../../typography/label';
import LoadingComponent from '../../../../feedbacks/loading';

type SelectCountryProps = {
    key?: string;
    selected?: IDataCountryResourceShortProps;
    options?: IDataCountryResourceShortProps[];
    qs?: string[];
    label?: string;
    hideLabel?: boolean;
    required?: boolean;
    disabled?: boolean;
    allowCreate?: boolean;
    onChange(selected?: IDataCountryResourceShortProps): void;
}

const SelectCountry: React.FC<SelectCountryProps> = (props: SelectCountryProps) => {
    const [activeSurface, setActiveSurface] = React.useState<string | undefined>();
    const [selected, setSelected] = React.useState<IDataCountryResourceShortProps | undefined>();
    const [loaded, setLoaded] = React.useState<boolean>(false);
    const [options, setOptions] = React.useState<IDataCountryResourceShortProps[]>([]);

    useEffect(() => {
        setSelected(props.selected);
    }, [props.selected]);

    useEffect(() => {
    }, [props]);

    useEffect(() => {
        init();
    }, []);

    const init = async () => {
        if (props.options) {
            setOptions(props.options);
        } else {
            const _countries = await DataCountryService.retrieve();
            setOptions(_countries);
        }
        setLoaded(true);
    }

    const groupOptions = (_options: IDataCountryResourceShortProps[]) => {
        const groups: {name: string, items: IDataCountryResourceShortProps[]}[] = [];
        
        _options.forEach((opt) => {
            const idx = groups.findIndex((g) => g.name.toLowerCase() === (opt.group || "").toLowerCase());
            if (idx > -1) {
                groups[idx].items.push(opt);
            } else {
                groups.push({name: opt.group || "Others", items: [opt]});
            }
        });

        return groups;
    }

    const getDropdownOptions = (_options: IDataCountryResourceShortProps[]) => {
        const groups = groupOptions(_options);
        const dropdownOptions: IDropdownOption[] = [];

        groups.forEach((group, idx) => {
            if (idx > 0) {dropdownOptions.push({key: 'divider_' + idx, text: "", itemType: DropdownMenuItemType.Divider});}
            dropdownOptions.push({key: 'group_' + idx, text: group.name, itemType: DropdownMenuItemType.Header});

            group.items.forEach((item) => {
                dropdownOptions.push({key: item.key, text: item.name});
            })
        });

        return dropdownOptions;
    }

    return <Stack>
        {props.hideLabel ? null : <Label style={{ padding: '3px 0px' }} size={'xsmall'} required={props.required}>{props.label || "Country"}</Label>}
        <Stack tokens={{childrenGap: 3}}>
            <Stack horizontal tokens={{ childrenGap: 10 }} verticalAlign={'center'} styles={{root: {width: '100%'}}}>
                {!loaded ? <LoadingComponent label={""} size={SpinnerSize.small} /> : null}
                <Stack styles={{root: {width: '100%'}}}>
                    <Dropdown key={props.key} disabled={props.disabled || !loaded}
                        selectedKey={selected?.key}
                        options={getDropdownOptions(options)}
                        onChange={(evt, opt) => {
                            const selected = options.find((o) => o.key === opt?.key as string);
                            props.onChange(selected);
                        }} />
                </Stack>
            </Stack>
        </Stack>
    </Stack>;
};

export default SelectCountry;
